import $ from 'jquery';
import CollapsibleFooter from '../../../js/components/collapsible-footer';
import NewsSlider from '../../../js/entries/discover-iqos/components/news-slider';
import RevealWhenVisible from '../../../js/components/reveal-when-visible';
import app from './app';
app();
$(() => {
    CollapsibleFooter.init();
    RevealWhenVisible.init();
    NewsSlider.init();
});
